export class WOWorkflowActionNames {
    static  ACTION_ReturnWorkOrder = 'Return Work Order';
    static ACTION_ApproveWork = 'Approve Work';
    static ACTION_CancelWorkOrder = 'Cancel Work Order';
    static ACTION_CancelWorkOrderAndCloseSR = 'Cancel Work Order and Close Service Request';
    static ACTION_ConfirmRiskAssessmentPassed = 'Risk Assessment Passed';
    static ACTION_StartWorkNoRA = 'Start Work - No RA';
    static ACTION_StartWork = 'Start Work';
    static ACTION_WorkDone = 'Work Done';
    static ACTION_PutOnHold = 'Put On Hold';
    static ACTION_Resume = 'Resume';
    static ACTION_RiskAssessmentFailed = 'Risk Assessment Failed';
    static ACTION_StartWorkRAPassed = "Start Work RA Passed";
    static ACTION_PermitChecked = "Permit Checked";
}